module.exports = __webpack_public_path__ + "static/media/hart.03eaeff8.png";